'use client';

import { TZDate, tz as tzContext } from '@date-fns/tz';
import { format } from 'date-fns';
import dynamic from 'next/dynamic';
import { memo, useEffect, useMemo, useState } from 'react';

type Props = {
    format?: string;
    serverTimezone?: string;
    children: Date | string;
};

const formatInTimeZone = (date: string | Date, tz: string, s: string) => {
    if (typeof date === 'string') {
        if (!date.toLowerCase().includes('z') && !date.includes('+')) {
            date = date + 'Z';
        }
        date = new Date(date);
    }
    if (!date) return '';

    const tzdate = new TZDate(date);

    return format(tzdate, s, {
        in: tzContext(tz),
    });
};

const LocalDateTimeComponent = ({ children, format, serverTimezone = 'UTC' }: Props) => {
    const serverText = useMemo(
        () => formatInTimeZone(children, serverTimezone, format ?? 'yyyy-MM-dd HH:mm:ss'),
        [children, format, serverTimezone]
    );

    const [text, setText] = useState(serverText);
    const [tz, setTz] = useState(serverTimezone);

    useEffect(() => {
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTz(userTz);
        setText(formatInTimeZone(children, userTz, format ?? 'yyyy-MM-dd HH:mm:ss'));
    }, [children, format]);

    return <span title={`Timezone: ${tz}`}>{text}</span>;
};

export const LocalDateTime = dynamic(() => Promise.resolve(memo(LocalDateTimeComponent)), { ssr: false });
